import React from "react";

export default function About() {
  return (
    <div>
      <h1>Over Suusje</h1>
    </div>
  );
}
